import { GenericModelApi } from "./GenericModelApi";
import { ApiSchema } from "./ApiClient";
import { EDocumentProductDataType } from "@/formTypes/EDocumentProductDataType";

export type DebitnoteProductDataType = Partial<ApiSchema["DebitnoteProduct"]["type"] & EDocumentProductDataType>;
export const DebitnoteProductApi = new GenericModelApi<"DebitnoteProduct", DebitnoteProductDataType>("DebitnoteProduct", "codigo");